module.exports = __webpack_public_path__ + "static/media/eg4.984db634.webp";